var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 3.5L10.75 6.5H13C13 7.69347 12.5259 8.83807 11.682 9.68198C10.8381 10.5259 9.69347 11 8.5 11C7.75 11 7.0225 10.8125 6.4 10.475L5.305 11.57C6.25982 12.1777 7.36821 12.5003 8.5 12.5C10.0913 12.5 11.6174 11.8679 12.7426 10.7426C13.8679 9.61742 14.5 8.0913 14.5 6.5H16.75L13.75 3.5ZM4 6.5C4 5.30653 4.47411 4.16193 5.31802 3.31802C6.16193 2.47411 7.30653 2 8.5 2C9.25 2 9.9775 2.1875 10.6 2.525L11.695 1.43C10.7402 0.822315 9.63179 0.499685 8.5 0.5C6.9087 0.5 5.38258 1.13214 4.25736 2.25736C3.13214 3.38258 2.5 4.9087 2.5 6.5H0.25L3.25 9.5L6.25 6.5",
    fill: "#64A4A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.d876fc58a2bed8056148414f99ca3c27.svg";
export { ForwardRef as ReactComponent };